import type { Locale } from '../../../shared/i18n';

export interface WeekdayOption { day: number; key: `day.${0 | 1 | 2 | 3 | 4 | 5 | 6}` }

const EN_ORDER = [0, 1, 2, 3, 4, 5, 6] as const;
const RU_ORDER = [1, 2, 3, 4, 5, 6, 0] as const;

export function weekdayOptions(locale: Locale): WeekdayOption[] {
  const order = locale === 'ru' ? RU_ORDER : EN_ORDER;
  return order.map((day) => ({ day, key: `day.${day}` as WeekdayOption['key'] }));
}

